import { Add, Delete } from '@mui/icons-material';
import React from 'react';
import { Button } from 'react-admin';

interface MemberActionButtonProps {
  /** Existing member count; > 0 shows the clear button, otherwise create. */
  count: number;
  loading: boolean;
  createLabel: string;
  clearLabel?: string;
  onCreate: () => void;
  onClear: () => void;
}

export const MemberActionButton: React.FC<MemberActionButtonProps> = ({
  count,
  loading,
  createLabel,
  clearLabel = 'clear members',
  onCreate,
  onClear,
}) =>
  count > 0 ? (
    <Button type="button" onClick={onClear} loading={loading} color="error">
      <Delete />
      {clearLabel}
    </Button>
  ) : (
    <Button type="button" onClick={onCreate} loading={loading}>
      <Add />
      {createLabel}
    </Button>
  );
